import Vue from 'vue';
import Router from 'vue-router';
import { cancelRequests } from '@/assets/js/http';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    },
    {
      path: '/help',
      name: 'help',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "help" */ '@/views/Help.vue'),
    },
    {
      path: '/explore',
      name: 'explore',
      component: () => import(/* webpackChunkName: "explore" */ '@/views/Explore.vue'),
    },
    {
      path: '/biomarkers',
      name: 'biomarkers',
      component: () => import(/* webpackChunkName: "biomarkers" */ '@/views/SearchBiomarker.vue'),
    },
    {
      path: '/download',
      name: 'download',
      component: () => import(/* webpackChunkName: "download" */ '@/views/Download.vue'),
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics.vue'),
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import(/* webpackChunkName: "contacts" */ '@/views/Contacts.vue'),
    },
    {
      path: '/rna/:rna/:analysisId/sample_ranks',
      name: 'sampleRanks',
      component: () => import(/* webpackChunkName: "sample_ranks" */ '@/views/SampleRanks.vue'),
      props: true,
    },
    {
      path: '/rna/:rnaType/:rna/:tumor',
      name: 'rna',
      component: () => import(/* webpackChunkName: "rna" */ '@/views/RNA.vue'),
      props: true,
    },
    {
      path: '/analysis/:analysisId',
      name: 'analysis',
      component: () => import(/* webpackChunkName: "analysis" */ '@/views/Analysis.vue'),
      props: true,
    },
  ],
});

router.beforeEach((to, from, next) => {
  cancelRequests('Request has been canceled for route changing');
  next();
});

export default router;
